import { confirmOnCloseAtom } from "@/financeModels/owasco/confirmOnClose";
import { useIsModelReadOnly } from "@/hooks/useFinancialDeckPermissions";
import { useIsModelAnonymous } from "@/hooks/useLiteModelToFull";
import { Box, Group, Stack, Text } from "@mantine/core";
import { useNetwork } from "@mantine/hooks";
import { useAtomValue } from "jotai";
import { MdOutlineCloudDone } from "react-icons/md";

export const SaveStatus = () => {
  const [isModelShared] = useIsModelReadOnly();
  const isSaving = useAtomValue(confirmOnCloseAtom);
  const isModelAnon = useIsModelAnonymous();
  const networkStatus = useNetwork();

  if (isModelShared) return null;

  if (networkStatus.online === false) {
    return (
      <Stack
        ml={"auto"}
        justify="center"
        align="center"
        opacity={isModelAnon ? 0 : 1}
      >
        <Text size="xs" c="red">
          Offline
        </Text>
      </Stack>
    );
  }

  return (
    <Box opacity={isModelAnon ? 0 : 1} visibleFrom="sm">
      <Group c={"gray.5"} mr={6}>
        {isSaving && (
          <Text size="xs" fw={"bold"}>
            Saving...
          </Text>
        )}
        {!isSaving && <MdOutlineCloudDone size={22} />}
      </Group>
    </Box>
  );
};
